<template functional>
  <div
    class="flex flex-col border-b border-gray-400 last:border-0 min-h-40"
    :class="$options.methods.mergeFunctionalRenderContextClasses(data, {
      'xl:flex-col': props.vertical,
      'xl:flex-row': !props.vertical
    })"
  >
    <slot name="titleWrapper">
      <div
        class="p-4"
        :class="{
          'w-1/3': !props.narrow && !props.withBackground,
          'w-1/4': props.narrow && !props.withBackground,
          'w-full': props.withBackground && !props.narrow,
          'pb-0': props.vertical && !props.withBackground,
          'bg-gray-400': props.withBackground,
          [props.titleWrapperClass]: true
        }"
        :style="props.titleWrapperStyle"
      >
        <slot
          name="title"
          :title="props.title"
        >
          <h3
            class="py-0 my-0 text-xl text-gray-800"
            v-text="props.title"
          />
        </slot>

        <slot name="description">
          <p
            v-if="props.description.length > 0"
            class="mt-1 text-sm italic text-gray-600"
            v-text="props.description"
          />
        </slot>
      </div>
    </slot>

    <div
      class="flex-1"
      :class="{ 'p-4 pb-8': !props.noPadding }"
    >
      <slot />
    </div>
  </div>
</template>

<script>
import { mergeFunctionalRenderContextClasses } from '@/helpers/utils'

export default {
  name: 'ObFormSection',

  props: {
    title: {
      type: String,
      default: ''
    },

    description: {
      type: String,
      default: ''
    },

    vertical: {
      type: Boolean,
      default: false
    },

    noPadding: {
      type: Boolean,
      default: false
    },

    narrow: {
      type: Boolean,
      default: false
    },

    withBackground: {
      type: Boolean,
      default: false
    },

    titleWrapperStyle: {
      type: String,
      default: ''
    },

    titleWrapperClass: {
      type: String,
      default: ''
    }
  },

  methods: {
    mergeFunctionalRenderContextClasses
  }
}
</script>
